import { formatBytes } from "../../../i18n/format";
import { useInterfaceLocale } from "./useInterfaceLocale";

/** A Source size in decimal units: "148 MB", "1.5 MB" / "1,5 MB". */
export function Bytes({ value }: { value: number | null | undefined }) {
  const locale = useInterfaceLocale();
  return (
    <span data-component="Bytes" className="tabular-nums">
      {formatBytes(value, locale)}
    </span>
  );
}
